module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manage-field pt-3"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-div"
  }, [_c('v-progress-circular', {
    staticClass: "loading-icon",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Dialog', {
    attrs: {
      "dialog": _vm.deleteCropDialog.show,
      "cardText": _vm.deleteCropDialog.cardText,
      "mainBtnText": _vm.deleteCropDialog.mainBtnText,
      "secondaryBtnText": _vm.deleteCropDialog.secondaryBtnText,
      "alertColor": true
    },
    on: {
      "update:dialog": function($event) {
        return _vm.$set(_vm.deleteCropDialog, "show", $event)
      },
      "mainBtnCallback": _vm.deleteCrop
    }
  }), _vm._v(" "), (_vm.deviceNamesDialog.show) ? _c('v-dialog', {
    attrs: {
      "width": "500",
      "content-class": "device-detail-dialog"
    },
    model: {
      value: (_vm.deviceNamesDialog.show),
      callback: function($$v) {
        _vm.$set(_vm.deviceNamesDialog, "show", $$v)
      },
      expression: "deviceNamesDialog.show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5 lighten-2 text-break"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ManageField.assignedDevices')) + "\n      ")]), _vm._v(" "), _c('v-card-text', [(_vm.deviceNamesDialog.names.length) ? _vm._l((_vm.deviceNamesDialog.names), function(name) {
    return _c('p', {
      key: name,
      staticClass: "mb-0",
      staticStyle: {
        "color": "#000000DE"
      }
    }, [_vm._v(_vm._s(name))])
  }) : _c('p', [_vm._v(_vm._s(_vm.$t('ManageField.noAssignedDevices')))])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.field) ? _c('v-container', {
    staticClass: "pt-5 px-0"
  }, [_c('h3', {
    staticClass: "header-field pt-3"
  }, [_c('a', {
    staticClass: "path-link-text",
    on: {
      "click": _vm.goToOrganizationHome
    }
  }, [_vm._v(_vm._s(_vm.$t('ManageField.dashboard')))]), _vm._v(" / " + _vm._s(_vm.field.name))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "section-header pt-5"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('ManageField.crops')))]), _vm._v(" "), _c('a', {
    staticClass: "add-elem-btn px-5",
    on: {
      "click": _vm.addCrop
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('ManageField.addCrop')))])]), _vm._v(" "), _c('v-layout', {
    staticClass: "crops-list",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.crops.length) ? _vm._l((_vm.crops), function(crop) {
    return _c('v-flex', {
      key: crop.id,
      staticClass: "px-3 py-3",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('v-card', {
      staticClass: "crop-card",
      on: {
        "click": function($event) {
          return _vm.editCrop(crop)
        }
      }
    }, [_c('v-card-title', [_c('v-layout', [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": require('@/assets/min-lot.png')
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs8": ""
      }
    }, [_c('p', {
      staticClass: "crop-header-title ma-0"
    }, [_vm._v(_vm._s(crop.name))]), _vm._v(" "), _c('p', {
      staticClass: "crop-header-subtitle ma-0"
    }, [_vm._v(_vm._s(crop.area) + " ha")]), _vm._v(" "), _c('p', {
      staticClass: "crop-header-subtitle ma-0"
    }, [_vm._v(_vm._s((crop.field && crop.field.name) || '-'))]), _vm._v(" "), _c('p', {
      staticClass: "crop-header-subtitle ma-0 crop-devices-clickable",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openDeviceNamesDialog(crop)
        }
      }
    }, [_vm._v(_vm._s(crop.devices && crop.devices.length == 1 ? _vm.$t('ManageField.cropDeviceQty', {
      devices: 1
    }) : _vm.$t('ManageField.cropDevicesQty', {
      devices: !crop.devices ? 0 : crop.devices.length
    })))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            staticClass: "menu-btn",
            attrs: {
              "dark": "",
              "text": "",
              "icon": "",
              "color": "#00202F"
            }
          }, on), [_c('v-icon', [_vm._v("more_horiz")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      staticClass: "pa-0"
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteCropHandler(crop, crop.device)
        }
      }
    }, [_c('v-list-item-title', {
      staticStyle: {
        "color": "#F93A2F"
      }
    }, [_vm._v(_vm._s(_vm.$t('ManageField.delete')))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
  }) : _c('div', {
    staticClass: "empty-div"
  }, [_c('p', {
    staticClass: "empty-list-text mt-1 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('ManageField.emptyCrops')))])])], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd5607ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationHome/ManageField.vue
// module id = 1766
// module chunks = 0